import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DownloadLeaseAgreementFeatureName} from './download-lease-agreement.reducer';
import { DownloadLeaseAgreementData, DownloadLeaseAgreementState, LeaseAgreementData } from '../../interfaces/download-lease-agreement';

const getDowlandLeaseAgreement = (data: DownloadLeaseAgreementState) : DownloadLeaseAgreementState => data;

export const DownloadLeaseAgreementFeatureSelector = createFeatureSelector<DownloadLeaseAgreementState>(DownloadLeaseAgreementFeatureName);

export const DownloadLeaseAgreementSelector = createSelector(
    DownloadLeaseAgreementFeatureSelector,
    getDowlandLeaseAgreement
);
